import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "divide-y space-y-10" }
const _hoisted_2 = { class: "font-medium mb-2" }

import { computed } from 'vue';

type Key = string | number;
type Item = Record<string, Key>;

interface Props {
  items?: Item[];
  groupBy: (e: Item) => Key;
  sorter?: (a: Key, b: Key) => number;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    items: { default: () => [] },
    groupBy: null,
    sorter: { type: Function, default: (a, b) =>
    typeof b === 'string' && typeof a === 'string'
      ? b.localeCompare(a)
      : typeof b === 'number' && typeof a === 'number'
      ? b - a
      : 1 }
  },
  setup(__props: any) {

const props = __props as { items: Item[], groupBy: (e: Item) => Key, sorter: (a: Key, b: Key) => number }



const groupedList = computed(() => {
  const tempList: { [key: string]: Item[] } = {};
  props.items.forEach((item) => {
    const group = props.groupBy(item);
    tempList[group] = [...(tempList[group] || []), item];
  });

  return Object.keys(tempList)
    .sort(props.sorter)
    .map((key) => ({ key, items: tempList[key] }));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupedList), (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.key,
        class: "pt-10"
      }, [
        _createElementVNode("p", _hoisted_2, [
          _renderSlot(_ctx.$slots, "header", _normalizeProps(_guardReactiveProps({ key: item.key })))
        ]),
        _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(item)))
      ]))
    }), 128))
  ]))
}
}

})